import {
  INCOTERM_EX_WORKS,
  INCOTERM_FREE_CARRIER,
  INCOTERM_CARRIAGE_PAID_TO,
  INCOTERM_CARRIAGE_AND_INSURANCE_PAID_TO,
  INCOTERM_DELIVERED_AT_TERMINAL,
  INCOTERM_DELIVERED_AT_PLACE,
  INCOTERM_DELIVERED_DUTY_PAID,
  INCOTERM_FREE_ALONGSIDE_SHIP,
  INCOTERM_FREE_ON_BOARD,
  INCOTERM_COST_AND_FREIGHT,
  INCOTERM_COST_INSURANCE_AND_FREIGHT
} from '@klear/constants/index'

export const INCOTERM_OPTIONS = [
  { value: INCOTERM_EX_WORKS, label: `Ex Works (${INCOTERM_EX_WORKS})` },
  { value: INCOTERM_FREE_CARRIER, label: `Free Carrier (${INCOTERM_FREE_CARRIER})` },
  { value: INCOTERM_CARRIAGE_PAID_TO, label: `Carriage Paid To (${INCOTERM_CARRIAGE_PAID_TO})` },
  {
    value: INCOTERM_CARRIAGE_AND_INSURANCE_PAID_TO,
    label: `Carriage and Insurance Paid To (${INCOTERM_CARRIAGE_AND_INSURANCE_PAID_TO})`
  },
  { value: INCOTERM_DELIVERED_AT_TERMINAL, label: `Delivered At Terminal (${INCOTERM_DELIVERED_AT_TERMINAL})` },
  { value: INCOTERM_DELIVERED_AT_PLACE, label: `Delivered At Place (${INCOTERM_DELIVERED_AT_PLACE})` },
  { value: INCOTERM_DELIVERED_DUTY_PAID, label: `Delivered Duty Paid (${INCOTERM_DELIVERED_DUTY_PAID})` },
  { value: INCOTERM_FREE_ALONGSIDE_SHIP, label: `Free Alongside Ship (${INCOTERM_FREE_ALONGSIDE_SHIP})` },
  { value: INCOTERM_FREE_ON_BOARD, label: `Free On Board (${INCOTERM_FREE_ON_BOARD})` },
  { value: INCOTERM_COST_AND_FREIGHT, label: `Cost and Freight (${INCOTERM_COST_AND_FREIGHT})` },
  {
    value: INCOTERM_COST_INSURANCE_AND_FREIGHT,
    label: `Cost, Insurance and Freight (${INCOTERM_COST_INSURANCE_AND_FREIGHT})`
  }
] as const

export const INCOTERM_CODES = [
  INCOTERM_EX_WORKS,
  INCOTERM_FREE_CARRIER,
  INCOTERM_CARRIAGE_PAID_TO,
  INCOTERM_CARRIAGE_AND_INSURANCE_PAID_TO,
  INCOTERM_DELIVERED_AT_TERMINAL,
  INCOTERM_DELIVERED_AT_PLACE,
  INCOTERM_DELIVERED_DUTY_PAID,
  INCOTERM_FREE_ALONGSIDE_SHIP,
  INCOTERM_FREE_ON_BOARD,
  INCOTERM_COST_AND_FREIGHT,
  INCOTERM_COST_INSURANCE_AND_FREIGHT
] as const

export type Incoterm = (typeof INCOTERM_CODES)[number]

export const INCOTERM_LLM_DESCRIPTION = INCOTERM_OPTIONS.map((o) => `${o.value} (${o.label})`).join(', ')
